export default __webpack_public_path__ + "static/media/information.aef3f92a.svg";